import { REPORT_ENDPOINT } from '../../../../../api/endpoint';
export const FOUR_WEEK_FORECAST_REPORT_ENDPOINT = `${REPORT_ENDPOINT}/four_week_forecast`;
